import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  planDescriptionContainer: {
    [theme.breakpoints.down("xs")]: {
      justifyContent: "space-evenly"
    }
  },
  mainContainer: {
    // width: "20vw",
    width: "310px",
    textAlign: "center",
    margin: "20px 0px",
    [theme.breakpoints.down("md")]: {
      width: "220px"
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%"
    }
  },
  titleStyle: {
    fontSize: 14,
    fontWeight: "bold",
    fontFamily: "Trebuchet"
  },
  titleStyleSub: {
    fontSize: 14,
    fontFamily: "Trebuchet"
  },
  descriptionStyle: {
    fontSize: 14,
    fontFamily: "Trebuchet",
    "& > p": {
      margin: 0
    }
  },
  descriptionStyleSub: {
    fontSize: 16,
    fontWeight: "bold",
    fontFamily: "Trebuchet",
    "& > p": {
      margin: 0
    }
  },
  imageStyle: {
    width: 35,
    height: "auto",
    [theme.breakpoints.down("xs")]: {
      width: "auto",
      height: 42
    }
  },
  columnContainer: {
    display: "flex",
    alignItems: "center",
    padding: "0px 10px",
    [theme.breakpoints.down("xs")]: {
      maxWidth: "45%",
      width: "45%",
      padding: "0px 5px"
    }
  },
  marginBottomContainer: {}
}));

export default styles;
